export const cleanDate = (dateString: string): string => {
  const date = new Date(dateString);

  if (!date) return "";

  let text = "";
  text +=
    date
      .getDate()
      .toString()
      .padStart(2, "0") + "-";
  let month = date.getMonth();
  month++;

  text += month.toString().padStart(2, "0") + "-";
  text += date.getFullYear();
  text += " " + date.getHours();
  text +=
    ":" +
    date
      .getMinutes()
      .toString()
      .padStart(2, "0");
  return text;
};

const numberToDateString = (value: number) => {
  return value > 9 ? `${value}` : `0${value}`;
};

export const dutchDateFromString = (dateString: string): string => {
  const date = new Date(dateString);

  if (date.toString() == "Invalid Date") return " ";

  return `${date.getFullYear()}-${numberToDateString(
    date.getMonth() + 1
  )}-${numberToDateString(date.getDate())}`;
};
